var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Prop, Mixins } from 'vue-property-decorator';
import LabelControl from "@/common/components/LabelControl.vue";
import PlainTextControl from "@/common/components/PlainTextControl.vue";
import TextAreaControl from "@/common/components/TextAreaControl.vue";
import NumericInputControl from "@/common/components/NumericInputControl.vue";
import SingleSelectTableCell from "@/common/components/SingleSelectTableCell.vue";
import { Savable } from '@/common/mixins/Savable';
import { Focusable } from '@/common/mixins/Focusable';
import LineControlWrapper from '@/common/types/LineControlWrapper';
import { EstimateType } from '../types/EstimateType';
var LineControl = /** @class */ (function (_super) {
    __extends(LineControl, _super);
    function LineControl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(LineControl.prototype, "tableTitleKey", {
        get: function () {
            if (this.$attrs.titleKey) {
                return this.$attrs.titleKey;
            }
            else {
                return this.value.key;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LineControl.prototype, "tableItemHeaderKey", {
        get: function () {
            if (this.$attrs.tableKey) {
                return this.$attrs.tableKey;
            }
            else {
                return this.value.itemHeaderKey;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LineControl.prototype, "columnTotalKey", {
        get: function () {
            if (this.$attrs.columnTotalKey) {
                return this.$attrs.columnTotalKey;
            }
            else if (this.value.columnTotalKey) {
                return this.value.columnTotalKey;
            }
            else {
                return "Total";
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LineControl.prototype, "columns", {
        get: function () {
            return this.value.columns;
        },
        enumerable: false,
        configurable: true
    });
    LineControl.prototype.getColumnHeader = function (column) {
        if (column.resourceParam && column.isKey) {
            return this.$t(column.value, null, [column.resourceParam]);
        }
        return column.isKey ? this.$t(column.value) : column.value;
    };
    Object.defineProperty(LineControl.prototype, "lineItems", {
        get: function () {
            return this.value.lineItems;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LineControl.prototype, "showRowTotals", {
        get: function () {
            return this.value.showRowTotals;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LineControl.prototype, "showColumnTotals", {
        get: function () {
            return this.value.showColumnTotals;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LineControl.prototype, "showActions", {
        get: function () {
            return this.value.showActions;
        },
        enumerable: false,
        configurable: true
    });
    LineControl.prototype.getAddButtonTooltip = function () {
        return this.$attrs.addButtonTooltip ? { html: true, content: this.$t(this.$attrs.addButtonTooltip) } : false;
    };
    Object.defineProperty(LineControl.prototype, "numberInputPlaceholderKey", {
        /**
         * Get the numeric placeholder key from attrs collection. Defaults to 'EnterValue' if nothing is found.
         */
        get: function () {
            var attrKey = this.$attrs.placeholderKey;
            if (!attrKey)
                attrKey = "EnterValue";
            return attrKey;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LineControl.prototype, "textAreaPlaceholderKey", {
        /**
         * Get the text are placeholder key from attrs collection. Defaults to 'Placeholder.TextArea' if nothing is found.
         */
        get: function () {
            var attrKey = this.$attrs.detailPlaceholderKey;
            if (!attrKey)
                attrKey = "Placeholder.TextArea";
            return attrKey;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LineControl.prototype, "showAddButton", {
        get: function () {
            var maxRows = this.value.maxRows;
            if (this.showActions) {
                return maxRows
                    ? this.lineItems.length < maxRows
                    : true;
            }
            else {
                return false;
            }
        },
        enumerable: false,
        configurable: true
    });
    LineControl.prototype.canDelete = function (lineItem) {
        return lineItem.canDelete
            && !lineItem.isReadOnly
            && this.value.lineItems.length > 1;
    };
    LineControl.prototype.addLineItem = function () {
        return __awaiter(this, void 0, void 0, function () {
            var targetId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.value.addLineItem();
                        this.forceSave();
                        return [4 /*yield*/, this.$nextTick()];
                    case 1:
                        _a.sent();
                        targetId = this.$attrs.id + "_lineItem_" + (this.value.lineItems.length - 1);
                        this.focusOnComponentId(targetId);
                        return [2 /*return*/];
                }
            });
        });
    };
    LineControl.prototype.setLineTypeAndName = function (item, selected) {
        if (selected == null || selected == undefined) {
            item.type = EstimateType.Unknown;
            item.name = "";
        }
        else {
            item.type = selected;
            var path = EstimateType[selected];
            item.name = this.$t("Enums.EstimateType." + path).toString();
        }
    };
    LineControl.prototype.removeLineItem = function (lineItem) {
        if (confirm(this.$t("Confirmation.DeleteRow").toString())) {
            this.value.removeLineItem(lineItem.key);
            this.forceSave();
        }
    };
    Object.defineProperty(LineControl.prototype, "showOptionSelector", {
        get: function () {
            return this.options != null
                && this.options.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    __decorate([
        Prop({ type: LineControlWrapper, required: true }),
        __metadata("design:type", typeof (_a = typeof LineControlWrapper !== "undefined" && LineControlWrapper) === "function" ? _a : Object)
    ], LineControl.prototype, "value", void 0);
    __decorate([
        Prop({ type: Array }),
        __metadata("design:type", Array)
    ], LineControl.prototype, "options", void 0);
    LineControl = __decorate([
        Component({
            name: "LineControl",
            components: {
                LabelControl: LabelControl,
                PlainTextControl: PlainTextControl,
                TextAreaControl: TextAreaControl,
                NumericInputControl: NumericInputControl,
                SingleSelectTableCell: SingleSelectTableCell
            },
            inheritAttrs: false
        })
    ], LineControl);
    return LineControl;
}(Mixins(Savable, Focusable)));
export default LineControl;
